import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var BarContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: ", "px;\n  height: ", "px;\n  overflow: hidden;\n"], ["\n  background: ", ";\n  border-radius: ", "px;\n  height: ", "px;\n  overflow: hidden;\n"])), function (props) {
  return props.color;
}, function (props) {
  var _a, _b, _c;

  return (props === null || props === void 0 ? void 0 : props.small) ? (_b = (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius) === null || _b === void 0 ? void 0 : _b.extraSmall : (_c = props.theme.attributes) === null || _c === void 0 ? void 0 : _c.borderRadius.default;
}, function (props) {
  var _a, _b;

  return (props === null || props === void 0 ? void 0 : props.small) ? (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs : (_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs;
});
var Progress = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "%;\n  background: ", ";\n  height: 100%;\n"], ["\n  width: ", "%;\n  background: ", ";\n  height: 100%;\n"])), function (props) {
  return props.width || 0;
}, function (props) {
  return props.color;
});
var templateObject_1, templateObject_2;
export { BarContainer, Progress };